import { Col, Menu, MenuProps, Row, message } from 'antd';
import React, { useMemo, useState } from 'react';
import {
  DatabaseOutlined,
  CalendarOutlined,
  FileTextOutlined,
  CarryOutOutlined,
} from '@ant-design/icons';
import SelectCategory from './SelectCategory';
import AvailableTime from './AvailableTime';
import useWidth from '@/helpers/widthUtil';
import BasicDetails from './BasicDetails';
import Summary from './Summary';
import moment from 'moment';

type MenuItem = Required<MenuProps>['items'][number];

export interface IerrorData {
  courseError: string;
  dateTimeError: string;
}

const BookingOnlineComponent = () => {
  //For responsive display
  const { isDesktopXL, isLaptop } = useWidth();

  //states
  const [activeTab, setActiveTab] = useState<number>(1);
  const [classId, setClassId] = useState<number>(); //Id for getting calander available dates
  const [startTime, setStartTime] = useState<string>();
  const [endTime, setEndTime] = useState<string>();
  const [dateRange, setDateRange] = useState<string>('');
  //for storing selected date on calendar
  const [courseDate, setCourseDate] = useState<string>(
    moment(new Date()).format('YYYY-MM-DD')
  );
  const [summaryData, setSummaryData] = useState({});
  const [courseData, setCourseData] = useState<any>({});
  const [errorData, setErrorData] = useState<IerrorData>({
    courseError: '',
    dateTimeError: '',
  });

  //For changing tab if summary data is available from Basic detail
  useMemo(() => {
    if (Object.keys(summaryData).length > 0) {
      setActiveTab(4);
    }
  }, [summaryData]);

  //Functions that change activeTab when click on menu
  const onTabClick = (id) => {
    //when menu 1 and 0 is clicked
    if (id == 1 || id == 0) {
      setActiveTab(id);
      setClassId(undefined); //to remove id if previously added
      setStartTime(''); //to remove start time
      setEndTime(''); //to remove end time
      setErrorData(undefined);
    } else if (id == 2) {
      if (classId) {
        setActiveTab(2);
        setStartTime(''); //to remove start time
        setEndTime(''); //to remove end time
        setErrorData({ ...errorData, courseError: '' });
      } else {
        setErrorData({ ...errorData, courseError: 'Please select any class' });
      }
    } else if (id == 3) {
      if (startTime && endTime) {
        setActiveTab(id);
        setErrorData({
          ...errorData,
          dateTimeError: '',
        });
      } else {
        setErrorData({
          ...errorData,
          dateTimeError: 'Please select available date and time',
        });
      }
      setSummaryData({});
    } else if (
      id == 4 &&
      Object.keys(summaryData).length > 0
      // startTime &&
      // endTime
    ) {
      setActiveTab(id);
    }
  };

  //To store Data from Select Category
  const categoryData = (data) => {
    if (Object.keys(data).length > 0) {
      setClassId(data?.id);
      setCourseData(data);
      setErrorData({ ...errorData, courseError: '' });
      onTabClick(2);
    } else {
      setErrorData({ ...errorData, courseError: 'Please select any class' });
    }
  };

  //getting start time and end time
  const handleStartEndTime = (start, end) => {
    setStartTime(start);
    setEndTime(end);
  };

  //To store basic details
  const submitToSummary = (data) => {
    if (data) {
      setSummaryData(data);
    }
  };

  //functions that returns items required to render menu
  function getItem(
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode
  ): MenuItem {
    return {
      key,
      icon,
      label,
    } as MenuItem;
  }

  //Items for Menu
  const items: MenuItem[] = [
    getItem('Select Class', '1', <DatabaseOutlined rev="" />),
    getItem('Date & Time', '2', <CalendarOutlined rev="" />),
    getItem('Basic Details', '3', <FileTextOutlined rev="" />),
    getItem('Summary', '4', <CarryOutOutlined rev="" />),
  ];

  //function for back button
  const backBtn = () => {
    onTabClick(activeTab - 1);
  };

  //function for next button
  const nextBtn = () => {
    onTabClick(activeTab + 1);
  };

  return (
    <div className="container my-5">
      <Row gutter={[32, 32]}>
        <Col span={isDesktopXL || isLaptop ? 5 : 24}>
          <Menu
            selectedKeys={[activeTab.toString()]}
            items={items}
            mode={isDesktopXL || isLaptop ? 'inline' : 'horizontal'}
            className="border rounded-lg shadow-sm w-100 m-0"
            onClick={(e) => {
              onTabClick(e.key);
            }}
          />
        </Col>
        <Col
          span={isDesktopXL || isLaptop ? 19 : 24}
          className="border rounded-lg px-4 py-2 w-100"
          style={{ overflowY: 'auto' }}
        >
          <div style={{ maxHeight: '650px' }}>
            {activeTab == 1 && (
              <SelectCategory
                categoryData={categoryData}
                errorData={errorData?.courseError}
                setErrorData={setErrorData}
                setClassId={setClassId}
              />
            )}
            {activeTab == 2 && (
              <AvailableTime
                classId={classId}
                handleStartEndTime={handleStartEndTime}
                backBtn={backBtn}
                nextBtn={nextBtn}
                errorData={errorData?.dateTimeError}
                setErrorData={setErrorData}
                startTime={startTime}
                endTime={endTime}
                setCourseDate={setCourseDate}
                courseDuration={courseData?.course_duration}
                setDateRange={setDateRange}
                dateRange={dateRange}
                courseName ={courseData?.name}
              />
            )}
            {activeTab == 3 && (
              <BasicDetails
                submitToSummary={submitToSummary}
                backBtn={backBtn}
                startTime={startTime}
                endTime={endTime}
              />
            )}
            {activeTab == 4 && (
              <Summary
                courseData={courseData}
                dateData={courseDate}
                start_time={startTime}
                end_time={endTime}
                summaryData={summaryData}
                backBtn={backBtn}
                dateRange={dateRange}
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BookingOnlineComponent;
